import { render, staticRenderFns } from "./UserScoreSearch.vue?vue&type=template&id=24e7b393&scoped=true&"
import script from "./UserScoreSearch.vue?vue&type=script&lang=js&"
export * from "./UserScoreSearch.vue?vue&type=script&lang=js&"
import style0 from "./UserScoreSearch.vue?vue&type=style&index=0&id=24e7b393&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e7b393",
  null
  
)

component.options.__file = "UserScoreSearch.vue"
export default component.exports